import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { AuthenticationProvider, LoadingStatus } from '@paycor/pacl';
import { PermissionsApiClient } from './apiClient';
import { RuntimeContext } from './common/RuntimeContext';
import { AuthService } from './common/interfaces/AuthService';
import Paths from './components/Paths';

import './App.scss';
import { FeatureFlagContextProvider } from './common/FeatureFlagContext';
import Forbidden from './views/common/forbidden/Forbidden';

function App() {
    const [isLoading, setIsLoading] = useState(true);

    const { app } = useContext(RuntimeContext);
    const authService = useContext(AuthenticationProvider.Context);

    const apiClient = useMemo(
        () => new PermissionsApiClient(authService as AuthService, app.ui.urlBase),
        [authService, app.ui.urlBase]
    );
    const featureFlags = useRef<any>();

    const [errorCode, setErrorCode] = useState<string>('');

    useEffect(() => {
        (async () => {
            try {
                featureFlags.current = await apiClient.getAllFeatureFlags();
                setIsLoading(false);
            } catch (error: unknown) {
                if (error instanceof Error && error.message === '403') {
                    setErrorCode('403');
                }

                setIsLoading(false);
            }
        })();
    }, [apiClient]);

    if (errorCode === '403') {
        return <Forbidden />;
    }

    return isLoading ? (
        <LoadingStatus />
    ) : (
        <React.Suspense fallback={<LoadingStatus />}>
            <FeatureFlagContextProvider featureFlagConfiguration={featureFlags.current}>
                <div className="app-container">
                    <div className="app">
                        <div className="content">
                            <Paths />
                        </div>
                    </div>
                </div>
            </FeatureFlagContextProvider>
        </React.Suspense>
    );
}

export default App;
